import { render } from "./ItemCheckEditor.vue?vue&type=template&id=226bb9bf&ts=true"
import script from "./ItemCheckEditor.vue?vue&type=script&lang=ts"
export * from "./ItemCheckEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__